import React from "react";

const ServiceDouane = () => {
  return (
    <>
      <main id="body-content">
        <section className="wide-tb-80">
          <div className="container pos-rel">
            <div className="row align-items-start">
              <div className="col-md-12 col-lg-8">
                <div className="row">
                  <div className="col-md-12 mb-5">
                    <div className="text-left">
                      <img
                        src="images/icon-box-3.jpg"
                        alt=""
                        className="rounded mb-4"
                      />
                      <h4 className="h4-md mb-3 txt-blue fw-7">
                        DOUANE & TRANSIT
                      </h4>
                      <p>
                        En qualité de{" "}
                        <strong>Commissionnaire en Douane Agréé</strong>, nous
                        effectuons les formalités douanières à l'import comme à
                        l'export aux Ports de Douala et Kribi ainsi qu'aux
                        aéroports internationaux de Douala et Yaoundé NSIMALEN.
                      </p>
                      <p>
                        Notre diligence dans les procédures complémentaires
                        effectuées auprès des agents maritimes, des acconiers et
                        des ADC (Aéroports du Cameroun), garantit une fluidité
                        exceptionnelle dans l'enlèvement de votre fret maritime
                        et aérien dans les enceintes portuaires et
                        aéroportuaires.
                      </p>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Nos points forts
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Expertise approfondie
                          des procédures douanières camerounaises
                        </li>
                        <li>
                          <i className="icofont-check"></i>Présence aux Ports de
                          Douala et Kribi
                        </li>
                        <li>
                          <i className="icofont-check"></i>Service aux aéroports
                          de Douala et Yaoundé NSIMALEN
                        </li>
                        <li>
                          <i className="icofont-check"></i>Traitement rapide des
                          dossiers import/export
                        </li>
                        <li>
                          <i className="icofont-check"></i>Relations
                          privilégiées avec les autorités portuaires et
                          aéroportuaires
                        </li>
                        <li>
                          <i className="icofont-check"></i>Coordination efficace
                          avec les agents maritimes et acconiers
                        </li>
                        <li>
                          <i className="icofont-check"></i>Conformité totale
                          avec la réglementation en vigueur
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Nos services
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Conseil et assistance
                          à la préparation des opérations d'import/export
                        </li>
                        <li>
                          <i className="icofont-check"></i>Production des
                          documents préliminaires aux opérations d'Import/export
                          (DI, RVC, ANOR, Certifications diverses...)
                        </li>
                        <li>
                          <i className="icofont-check"></i>Levée des
                          déclarations douanières sous les régimes douaniers
                          définitifs et suspensifs
                        </li>
                        <li>
                          <i className="icofont-check"></i>Évaluation du risque
                          douanier
                        </li>
                        <li>
                          <i className="icofont-check"></i>Gestion du
                          contentieux douanier
                        </li>
                        <li>
                          <i className="icofont-check"></i>Gestion des
                          procédures auprès des agents Maritimes et Acconiers
                        </li>
                        <li>
                          <i className="icofont-check"></i>Cautionnement des
                          droits de douane et conteneurs
                        </li>
                        <li>
                          <i className="icofont-check"></i>Évaluation des
                          risques d'avarie
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <aside className="sidebar-spacer row">
                  <div className="sidebar-primary col-lg-12 col-md-6">
                    <div className="widget-wrap text-center bg-sky-blue rounded py-5">
                      <div className="mb-2">
                        <i className="icofont-headphone-alt icofont-4x"></i>
                      </div>
                      <h3 className="h3-md fw-5 txt-orange mb-4">
                        Besoin d'aide?
                      </h3>
                      <p>
                        Contactez notre
                        <br /> support technique 24/7
                      </p>
                      <a
                        href="/contact"
                        className="btn-theme bg-secondary mt-3"
                      >
                        Contacter <i className="icofont-rounded-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="sidebar-secondary col-lg-12 col-md-6">
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Nos services</h3>
                      <div className="blog-list-categories">
                        <ul className="list-unstyled">
                          <li>
                            <a href="/servicedebours">Les Debours</a>
                          </li>
                          <li>
                            <a href="/serviceprestations">Les Prestations</a>
                          </li>
                          <li className="active">
                            <a href="/servicedouane">Douane & Transit</a>
                          </li>
                          <li>
                            <a href="/servicetransport">
                              Transport & Logistique
                            </a>
                          </li>
                          <li>
                            <a href="/servicepetrolier">
                              Transport Produits Pétroliers
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Notre Photothèque</h3>
                      <ul className="photo-thumbs">
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-1.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-1.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-2.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-2.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-3.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-3.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-4.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-4.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-5.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-5.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-6.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-6.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-7.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-7.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-8.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-8.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-9.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-9.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default ServiceDouane;
